import * as select from './datiq-select-value-matches-options.validator';

const DatiqInputValidatorsSelect = {
    ...select,
};

export { DatiqInputValidatorsSelect };
